import { useCallback } from 'react';

import { useRange } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';

import {
	INSTANT_SEARCH_TRENDING_FILTER,
	INSTANT_SEARCH_TRENDING_FILTER_VALUE,
} from 'src/app/pages/search/shared/consts';

type Result = ModelHookResult<
	undefined,
	{
		filterByTrending: () => void;
	}
>;

export function useFilterByTrending(): Result {
	const { refine } = useRange({
		attribute: INSTANT_SEARCH_TRENDING_FILTER,
		precision: 1,
	});
	const track = useTracking();

	return {
		actions: {
			filterByTrending: useCallback(() => {
				void track('search', { q: '', context: 'landing_trending_button' });
				refine([INSTANT_SEARCH_TRENDING_FILTER_VALUE, undefined]);
			}, [refine, track]),
		},
	};
}
